import { Constants } from '@/utils/constants';
import { atom } from 'recoil';
import persistAtom from './recoilPersist';

/**
 * オプション解約画面へ引き継ぐ対象情報。
 * オプション種別ごとに追加パラメータが異なるため、共通枠の中に個別情報を持たせている。
 */
export type QuitOptionInfoStateType = {
  option_name: string;
  use_status: string;
  parameters: {
    option_info: {
      option_code: string;
      order_type: number;
      tngr_mesh_wifi_option_info:
        | {
            preferred_date: string;
            preferred_time_zone: string;
            availableTsunagaruMeshWifi?: boolean;
          }
        | undefined;
      amuelink_option_info: { contract_no: number } | undefined;
      ps5_option_info: { lease_quit_type: number } | undefined;
      bravia_option_info: { lease_quit_type: number } | undefined;
    };
  };
};

/**
 * 解約対象オプション情報を保持する state。
 * 一覧画面から詳細・確認画面へ遷移する際に、解約対象のオプション名と送信パラメータを引き回す。
 */
export const QuitOptionInfoState = atom<QuitOptionInfoStateType>({
  key: 'QuitOptionInfoState',
  default: {
    option_name: '',
    use_status: '',
    parameters: {
      option_info: {
        option_code: '',
        order_type: Constants.OptionOrderType.SIMPLE_QUIT,
        tngr_mesh_wifi_option_info: undefined,
        amuelink_option_info: undefined,
        ps5_option_info: undefined,
        bravia_option_info: undefined,
      },
    },
  },
  effects_UNSTABLE: [persistAtom],
});

export default QuitOptionInfoState;
